// see https://polaris.shopify.com/components/structure/app-provider#section-using-linkcomponent
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

const IS_EXTERNAL_LINK_REGEX = /^(?:[a-z][a-z\d+.-]*:|\/\/)/;

type LinkParams = {
  children?: React.ReactNode;
  url: string;
  external?: boolean;
  target?: string;
  rel?: string;
  ref: any;
};
export default function Link ({
  children,
  url = '',
  external,
  ref,
  target,
  rel,
  ...rest
}: LinkParams) {
  // react-router only supports links to pages it can handle itself. It does not
  // support arbirary links, so anything that is not a path-based link should
  // use a reglar old `a` tag
  if (external || IS_EXTERNAL_LINK_REGEX.test(url)) {
    target = '_blank';
    rel = 'noopener noreferrer';
    return (
      <a href={url} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <ReactRouterLink to={url} {...rest}>
      {children}
    </ReactRouterLink>
  );
}
export { Link };
